export default "__VITE_ASSET__BLurCxA5__"